var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-stream"},[_vm._v("\n  "+_vm._s(_vm.displayedContent)),(!_vm.isFinished)?_c('span',{staticClass:"blinking-cursor"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }